import React, { useMemo } from "react";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import Interference from 'components/sports/srf/component/Interference'
import { isStartListStatus, isLiveStatus } from "helpers/status";

//General

import { TableColumnsStartList as ColumnsStartList, TableColumnsLive as ColumnsLive, TableColumnsFinish as ColumnsFinish } from 'components/sports/srf/events/results/Columns'
import { TableExpanded } from 'components/sports/srf/events/results/TableExpanded'

//import TableMin from "components/table/TableMin";
import { useViewport } from 'components/general/useViewPort'


const getConfiguration = (data) => {

    const columnsAdded = [];
    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;

    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            isStartList: isStartListStatus(resultStatus),
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };

    configuration.caption = <CaptionTable
        leftCol={<h3 className="text-dark">{data && data?.results?.eventUnit?.description}</h3>}
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartListStatus(resultStatus)
        ? [{ id: 'Bib', desc: false }]
        : [{ id: 'Rank', desc: false }]


    configuration.columns = isStartListStatus(resultStatus)
        ? ColumnsStartList()
        : isLiveStatus(resultStatus) ? ColumnsLive()
            : ColumnsFinish();

    return configuration;
};


const SrfResults = ({ data }) => {
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;

    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(data, breakPoint), [resultStatus, breakPoint]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <TableExpanded row={row?.original} officials={data?.results?.officials} />
        }
        />
        // eslint-disable-next-line
    ), [resultStatus, breakPoint]);


    //const items = data?.results?.items;
    //const showAllExtendedResults = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'WAVE'));
    //const showAll = showAllExtendedResults;
    //if (!showAll) hiddenColumns.push('Expander')

    //Si el contenido de una columna esta vacia la ocultamos(ver casos)
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []

    return (
        <>
            {data?.results?.items
                ? (
                    <>
                        < MirsTable
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //subcomponente a renderizar, extended
                            renderRowSubComponent={renderRowSubComponent}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde 
                            hiddenColumns={hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            id={`mirs-table-result-${rsc}`}
                        />
                        <Interference data={data?.results?.items} />
                    </>
                ) : (
                    ''
                )
            }
        </>
    );
};

export default SrfResults;
